import { ResizedImg } from '../ResizedImg/ResizedImg';

export const PictureInsert = ({
  url,
  priority = false,
}: {
  url: string;
  priority?: boolean;
}) => (
  <div className="interaction-aside__picture" data-testid="main-picture">
    <ResizedImg
      alt=""
      fallBackFormat="1600x0"
      format="768x0"
      fill
      sizes="(max-width: 768px) 100vw, 50vw"
      loading={priority ? 'eager' : 'lazy'}
      style={{ objectFit: 'cover' }}
      priority={priority}
      {...priority && { fetchPriority: 'high' }}
      src={url}
    />
  </div>
);
